/**
 * Front-end entry: global SCSS + Bootstrap Collapse (FAQ accordion data API).
 * Dropdown: required for header "Mein Dashboard" menu (`data-bs-toggle="dropdown"`).
 * Uses bootstrap/js/src (ESM) to avoid the Rollup CommonJS helper chunk from UMD bundles.
 */
import Collapse from 'bootstrap/js/src/collapse.js';
import Dropdown from 'bootstrap/js/src/dropdown.js';
import { initZkHeader } from './header.js';
import { initZkViewFiltersDetails } from './view-filters.js';
import { registerZkHeaderScrollBehavior } from '../src/js/header-scroll.js';
import '../scss/main.scss';

import { initZkTaxCalculators } from '../src/js/tax-calculator.js';
import { initZkNewsletterUtm } from '../src/js/newsletter-signup.js';
import { initZkWebformAjaxConfirm } from '../src/js/webform-ajax-confirm.js';
import { initZkFormEnterSubmit } from '../src/js/form-enter-submit.js';
import { initZkCookieConsentDetails, registerZkCookieConsentDetails } from '../src/js/cookie-consent-details.js';

// Side effect: registers Collapse + Dropdown data-API handlers on document.
void Collapse;
void Dropdown;

function zkAttachDrupalBehaviors() {
  if (typeof Drupal !== 'undefined' && typeof Drupal.attachBehaviors === 'function') {
    Drupal.attachBehaviors(document, window.drupalSettings || {});
  }
}

function zkScheduleNonCriticalInit() {
  const run = () => {
    if (document.querySelector('details.zk-view-filters-collapsible')) {
      initZkViewFiltersDetails();
    }
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 2500 });
  }
  else {
    window.setTimeout(run, 1);
  }
}

registerZkHeaderScrollBehavior(window);
registerZkCookieConsentDetails();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    zkAttachDrupalBehaviors();
    initZkHeader();
    zkScheduleNonCriticalInit();
    initZkTaxCalculators();
    initZkNewsletterUtm();
    initZkWebformAjaxConfirm();
    initZkFormEnterSubmit();
    initZkCookieConsentDetails();
  });
}
else {
  zkAttachDrupalBehaviors();
  initZkHeader();
  zkScheduleNonCriticalInit();
  initZkTaxCalculators();
  initZkNewsletterUtm();
  initZkWebformAjaxConfirm();
  initZkFormEnterSubmit();
  initZkCookieConsentDetails();
}
